<template>
	<div
		class="modal fade"
		:class="'md_' + id"
		:data-backdrop="static != undefined ? 'static' : false"
	>
		<div
			class="modal-dialog"
			:class="size != undefined ? 'modal-' + size : ''"
		>
			<div class="modal-content">
				<div
					class="modal-header"
					v-if="title != '' && title != undefined"
				>
					<button class="close" @click="close">
						<i class="fa fa-close"></i>
					</button>
					<h4 class="modal-title">{{ title }}</h4>
				</div>
				<div v-if="$slots.body != undefined" class="modal-body">
					<slot name="body" />
				</div>
				<div v-if="$slots.footer != undefined" class="modal-footer">
					<slot name="footer" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import md4 from 'js-md4';
	export default {
		name: 'AppModal',
		props: ['title', 'size', 'static'],
		data() {
			return {
				id: md4(new Date() + Math.random()),
			};
		},
		methods: {
			open() {
				$('.md_' + this.id).modal('show');
			},
			close() {
				$('.md_' + this.id).modal('hide');
			},
		},
	};
</script>
<style scoped>
	h4.modal-title {
		font-size: 17px;
	}
</style>



// WEBPACK FOOTER //
// src/app-components/modal.vue